import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "grid grid-cols-2 gap-x-4 mt-4"
}
const _hoisted_2 = { class: "flex flex-col gap-y-4" }
const _hoisted_3 = { class: "flex items-center text-black-lp-300" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-800 font-medium capitalize" }, " COD ", -1)
const _hoisted_5 = { class: "flex items-center mt-1 gap-1 flex-wrap text-20px text-black-lp-300 font-semibold" }
const _hoisted_6 = { class: "text-12px font-medium" }
const _hoisted_7 = { class: "flex items-center text-black-lp-300" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-12px text-gray-lp-800 font-medium capitalize" }, " Non COD ", -1)
const _hoisted_9 = { class: "flex items-center mt-1 gap-1 flex-wrap text-20px text-black-lp-300 font-semibold" }
const _hoisted_10 = { class: "text-12px font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DonutChart = _resolveComponent("DonutChart")!
  const _component_bullet_point = _resolveComponent("bullet-point")!
  const _component_CardDashboardClient = _resolveComponent("CardDashboardClient")!

  return (_openBlock(), _createBlock(_component_CardDashboardClient, {
    title: _ctx.$t('dashboard.codVsNonCod')
  }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            class: "mt-4",
            height: "75%"
          }))
        : (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_DonutChart, {
              chartSeries: _ctx.chartData,
              chartColor: _ctx.chartColor,
              chartHeight: "150"
            }, null, 8, ["chartSeries", "chartColor"]),
            _createVNode("div", _hoisted_2, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_bullet_point, {
                    style: {"color":"#36B37E"},
                    class: "w-2 mr-1"
                  }),
                  _hoisted_4
                ]),
                _createVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.dataCodVsNonCod.cod.percentage) + "% " + _toDisplayString(_ctx.$t("dashboard.resi")) + " ", 1),
                  _createVNode("div", _hoisted_6, " (" + _toDisplayString(_ctx.dataCodVsNonCod.cod.resi) + " " + _toDisplayString(_ctx.$t("dashboard.resi")) + ") ", 1)
                ])
              ]),
              _createVNode("div", null, [
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_bullet_point, {
                    style: {"color":"#C0EBCF"},
                    class: "w-2 mr-1"
                  }),
                  _hoisted_8
                ]),
                _createVNode("div", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_ctx.dataCodVsNonCod.nonCod.percentage) + "% " + _toDisplayString(_ctx.$t("dashboard.resi")) + " ", 1),
                  _createVNode("div", _hoisted_10, " (" + _toDisplayString(_ctx.dataCodVsNonCod.nonCod.resi) + " " + _toDisplayString(_ctx.$t("dashboard.resi")) + ") ", 1)
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["title"]))
}